import {JackpotBetWidgetBgMRGBox} from "./jackpot-bet-widget-bg.mrgreen.box";

export const JackpotBetWidgetBgMRGCisBox = JackpotBetWidgetBgMRGBox;